
export class AzureADServicePrincipalSummaryModel {
  id: string;
  appId: string;
  appOwnerOrganizationId: string;
  appDisplayName: string;
  appPublisherName: string;
}
